<template>
  <router-view />
</template>

<script>
export default {
  name: 'Settings',
};
</script>
